import { useEffect, useState } from "react"
import api from "../../utils/api"

// Manager side: which units of a property wait for their assigned tenant to
// approve and pay, keyed by unit ID. Only managers of the property can load it;
// anyone else simply gets an empty list.
export function usePendingUnitApprovals(propertyId, enabled = true, refreshKey = 0) {
  const [byUnit, setByUnit] = useState({})

  useEffect(() => {
    if (!enabled || !propertyId) {
      setByUnit({})
      return undefined
    }
    let active = true
    api
      .get(`/frp/tenancy-invitations/sent?propertyId=${encodeURIComponent(propertyId)}`)
      .then((response) => {
        if (!active) return
        const list = Array.isArray(response?.data?.invitations) ? response.data.invitations : []
        setByUnit(Object.fromEntries(list.map((row) => [String(row.unitId), row])))
      })
      .catch(() => {
        // A missing label must never break the unit list.
        if (active) setByUnit({})
      })
    return () => {
      active = false
    }
  }, [propertyId, enabled, refreshKey])

  return byUnit
}
